import React from 'react';
import { Autocomplete, Grid, TextField, InputLabel } from '@mui/material';
import { LOCATION_TYPE, LOCATION_TYPE_OPTIONS } from 'enum/location';
import PropTypes from 'prop-types';

import CustomMap from 'components/CustomMap';

const DescriptionTab = ({ values, errors, touched, onChange }) => (
  <Grid container spacing={4} data-testid="object-description-tab">
    <Grid item xs={12} data-testid="object-description">
      <InputLabel sx={{ fontSize: 14 }} data-testid="object-description-label">
        Description
      </InputLabel>
      <TextField
        fullWidth
        variant="standard"
        name="description"
        placeholder="Description"
        value={values.description}
        onChange={onChange}
        error={Boolean(touched.description && errors.description)}
        helperText={!!touched.description && errors.description}
        inputProps={{ 'data-testid': 'object-description-input' }}
      />
    </Grid>
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={6} data-testid="object-location">
          <InputLabel sx={{ fontSize: 14 }} data-testid="object-location-label">
            Location
          </InputLabel>
          <Autocomplete
            data-testid="object-location-select"
            options={LOCATION_TYPE_OPTIONS}
            getOptionLabel={(option) => option.label}
            value={LOCATION_TYPE_OPTIONS.find((loc) => loc.value === values.location) || LOCATION_TYPE.UNDEFINED}
            onChange={(event, newValue) => onChange({ target: { name: 'location', value: newValue.value } })}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  'data-testid': 'object-location-input',
                }}
                variant="standard"
                error={Boolean(touched.location && errors.location)}
                helperText={!!touched.location && errors.location}
              />
            )}
          />
        </Grid>
      </Grid>
    </Grid>
    {values.location === LOCATION_TYPE.COORDINATES && (
      <>
        <Grid item xs={12} md={6} data-testid="object-latitude">
          <TextField
            fullWidth
            variant="standard"
            type="number"
            name="lat"
            label="Latitude"
            value={values.lat}
            onChange={onChange}
            error={Boolean(touched.lat && errors.lat)}
            helperText={!!touched.lat && errors.lat}
            inputProps={{ 'data-testid': 'object-latitude-input' }}
          />
        </Grid>
        <Grid item xs={12} md={6} data-testid="object-longitude">
          <TextField
            fullWidth
            variant="standard"
            type="number"
            name="lng"
            label="Longitude"
            value={values.lng}
            onChange={onChange}
            error={Boolean(touched.lng && errors.lng)}
            helperText={!!touched.lng && errors.lng}
            inputProps={{ 'data-testid': 'object-longitude-input' }}
          />
        </Grid>
        <Grid item xs={12} data-testid="object-geolocation-map">
          <CustomMap
            center={{ lat: values.lat, lng: values.lng }}
            onCenterChange={(center) => {
              onChange({ target: { name: 'lat', value: center.lat } });
              onChange({ target: { name: 'lng', value: center.lng } });
            }}
          />
        </Grid>
      </>
    )}
  </Grid>
);

DescriptionTab.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DescriptionTab;
